import { ChevronDown, ChevronUp } from '@atom-learning/icons'
import * as RadixSelect from '@radix-ui/react-select'
import * as React from 'react'

import { styled } from '~/styled'

import { Icon } from '../icon/Icon'

const Content = styled(RadixSelect.Content, {
  base: [
    'bg-white',
    'rounded-md',
    'shadow-lg',
    'z-10',
    'overflow-hidden',
    'will-change-transform',
    'will-change-opacity',
    '[--slide-opacity-out:0]',
    'data-[side=top]:[--slide-direction-out-y:-4px]',
    'data-[side=right]:[--slide-direction-out-x:4px]',
    'data-[side=bottom]:[--slide-direction-out-y:4px]',
    'data-[side=left]:[--slide-direction-out-x:-4px]',
    'motion-safe:data-[state=open]:animate-slide-direction-in',
    'motion-safe:data-[state=closed]:animate-slide-direction-out'
  ],
  variants: {
    position: {
      popper: [
        'max-h-(--radix-select-content-available-height)',
        'min-w-(--radix-select-trigger-width)'
      ],
      'item-aligned': []
    }
  }
})

const Viewport = styled(RadixSelect.Viewport, {
  base: ['p-1', 'w-full'],
  variants: {
    position: {
      popper: ['h-(--radix-select-content-available-height)'],
      'item-aligned': []
    }
  }
})

const ScrollUpButton = styled(RadixSelect.ScrollUpButton, {
  base: ['flex', 'items-center', 'justify-center', 'h-6', 'cursor-default']
})

const ScrollDownButton = styled(RadixSelect.ScrollDownButton, {
  base: ['flex', 'items-center', 'justify-center', 'h-6', 'cursor-default']
})

type SelectMenuContentProps = React.ComponentPropsWithRef<
  typeof RadixSelect.Content
>

export const SelectMenuContent = React.forwardRef<
  HTMLDivElement,
  SelectMenuContentProps
>(({ children, position = 'popper', sideOffset = 4, ...props }, ref) => (
  <RadixSelect.Portal>
    <Content ref={ref} position={position} sideOffset={sideOffset} {...props}>
      <ScrollUpButton>
        <Icon is={ChevronUp} className="text-grey-700 size-4" />
      </ScrollUpButton>
      <Viewport position={position}>{children}</Viewport>
      <ScrollDownButton>
        <Icon is={ChevronDown} className="text-grey-700 size-4" />
      </ScrollDownButton>
    </Content>
  </RadixSelect.Portal>
))

SelectMenuContent.displayName = 'SelectMenuContent'
